'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var regex = /^(?:(?:([^:\/?#]+):)?(?:\/\/([^:\/?#]+)(?::([0-9]+))?)+?)?([^?#]+)?(?:\?([^#]*))?(?:#(.+))?/;

var getDefaultPort = function getDefaultPort(protocol) {
  var normalizedProtocol = (protocol || '').toLowerCase();
  if (!normalizedProtocol) return null;

  if (normalizedProtocol === 'http') return 80;
  if (normalizedProtocol === 'https') return 443;

  return null;
};

var parseUrl = exports.parseUrl = function parseUrl(url) {
  var _regex$exec = regex.exec(url),
      _regex$exec2 = _slicedToArray(_regex$exec, 7),
      protocol = _regex$exec2[1],
      hostname = _regex$exec2[2],
      port = _regex$exec2[3],
      path = _regex$exec2[4],
      query = _regex$exec2[5],
      hash = _regex$exec2[6];

  return {
    protocol: protocol,
    hostname: hostname,
    port: port !== undefined ? parseInt(port, 10) : getDefaultPort(protocol),
    path: path,
    query: query,
    hash: hash
  };
};

var isDefaultPort = function isDefaultPort(descriptor) {
  if (!descriptor.port) return true;
  if (!descriptor.protocol) return true;

  var protocol = (descriptor.protocol || '').toLowerCase();

  if (protocol === 'http' && descriptor.port === 80) return true;
  if (protocol === 'https' && descriptor.port === 443) return true;

  return false;
};

var buildUrl = exports.buildUrl = function buildUrl(descriptor) {
  return [descriptor.hostname ? (descriptor.protocol || 'https') + '://' : '', descriptor.hostname, isDefaultPort(descriptor) ? '' : ':' + descriptor.port, descriptor.hostname && descriptor.path && descriptor.path.substr(0, 1) !== '/' ? '/' + descriptor.path : descriptor.path, descriptor.query ? '?' + descriptor.query : '', descriptor.hash ? '#' + descriptor.hash : ''].join('');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.161/js/helpers/url.js
// module id = 41
// module chunks = 0